// const development_url = "http://localhost:8079"; // 开发地址

const development_url = "/dev-api"; // 正式域名
const production_url = "/dev-api"; // 正式域名

export default {
    baseUrl: (process.env.NODE_ENV === "development" ? development_url : production_url), //接口地址
    headerMenu: false,
    appName: "国经人力",
    remoteType: "pc",
}


// WEBPACK FOOTER //
// ./src/config/index.js